export const ANAGOG_FCM_INDICATION = "com.anagog.jedai.notification.source"